
import { Link } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PricingPlans from "./pricing/PricingPlans";

const Pricing = () => {
  return (
    <section className="py-16 bg-card/30" id="pricing">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Simple, <span className="text-godyspo-gold">Transparent</span> Pricing</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Start your 30-day free trial today - no commitments, cancel anytime
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <Tabs defaultValue="monthly" className="flex flex-col items-center mb-8">
            <TabsList>
              <TabsTrigger value="monthly">Monthly</TabsTrigger>
              <TabsTrigger value="annually">Annually</TabsTrigger>
            </TabsList>
            
            <TabsContent value="monthly" className="w-full mt-8">
              <PricingPlans billingPeriod="monthly" />
            </TabsContent>
            
            <TabsContent value="annually" className="w-full mt-8">
              <PricingPlans billingPeriod="annually" />
            </TabsContent>
          </Tabs>

          <div className="text-center mt-8 text-sm text-muted-foreground">
            Start your free trial today with full access to all features.
            <br />
            Need a custom solution? <Link to="/contact" className="text-godyspo-gold hover:underline">Contact us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
